import {
  type ApiError,
  AppError,
  type EventPayload,
  EventType,
  emitSystemError,
} from '@imprivata-cloud/authn';

export const normalizeError = (error: unknown): EventPayload => {
  const eventType =
    error instanceof AppError ? EventType.ERROR : EventType.INTERNAL_ERROR;
  return {
    event: eventType,
    data:
      error instanceof AppError ? error : emitSystemError(error as ApiError),
  };
};

export const wait = (delayMs: number) =>
  new Promise(resolve => {
    window.setTimeout(resolve, delayMs);
  });
